import { FC } from "react";
import { observer } from "mobx-react";
import { BoardAssignsSignatureForm } from "./boardAssignsSignatureDomain";
import {
  CheckboxGroupQuestion,
  TextAreaQuestion,
  TextQuestion,
  YesNoQuestion,
} from "@/dbot/common/commonComponents";
import { VBox } from "@/components-v2/Box";

import { useTranslation } from "@/stores/RootStoreContext";

export const BoardAssignsSignatureView: FC<{ form: BoardAssignsSignatureForm }> = observer(
  ({ form }) => {
    const { t } = useTranslation();

    return (
      <VBox gap={"md"}>
        <CheckboxGroupQuestion
          question={{ key: "decisions.signature.whoShouldHave" }}
          field={form.signatureAssignedTo}
          isLocked={form.isProjectLocked}
        />
        {form.isShowNamedPersonInput && (
          <>
            <CheckboxGroupQuestion
              question={{ key: "decisions.signature.choose-board-member" }}
              field={form.signatureAssignedToNamedBoardMembers}
              isLocked={form.isProjectLocked}
            />
            <TextAreaQuestion
              question={t("decisions.signature.assignedTo.namedPersons")}
              field={form.signatureAssignedToNamedPersons}
              isLocked={form.isProjectLocked}
            />
          </>
        )}
        {form.isShowNamedPersonJointlyInput && (
          <>
            <CheckboxGroupQuestion
              question={{ key: "decisions.signature.choose-board-member-jointly" }}
              field={form.signatureAssignedToNamedBoardMembersJointly}
              isLocked={form.isProjectLocked}
            />
            <TextAreaQuestion
              question={t("decisions.signature.assignedTo.namedPersonsJointly")}
              field={form.signatureAssignedToNamedPersonsJointly}
              isLocked={form.isProjectLocked}
            />
          </>
        )}
        {form.isShowOtherRegulationsInput && (
          <TextQuestion
            question={t("decisions.signature.textForOtherRegulation")}
            field={form.signatureAssignedOtherRegulation}
            isLocked={form.isProjectLocked}
          />
        )}
        <YesNoQuestion
          question={t("decisions.signature.previousDecisionsAllocation")}
          field={form.revokeBoardDecisionsSignatures}
          isLocked={form.isProjectLocked}
        />
      </VBox>
    );
  },
);
